/*
  Pagina de articol: legăturile cuprinsului (id pe H2-uri, fără diacritice),
  evidențierea secțiunii curente și tabelele din conținut puse într-un
  container care derulează orizontal pe mobil. Conținutul nu se schimbă altfel.
*/
(function () {
  function slug(text) {
    return (
      String(text || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'sectiune'
    );
  }

  function scrollable(el) {
    var ox = window.getComputedStyle(el).overflowX;
    return ox === 'auto' || ox === 'scroll';
  }

  function init() {
    var content = document.querySelector('[data-mcb-content]');
    if (!content) return;

    // Tabelele fără container de derulare primesc .xl-scroll.
    content.querySelectorAll('table').forEach(function (table) {
      var parent = table.parentElement;
      if (parent && (parent.classList.contains('xl-scroll') || scrollable(parent))) return;
      var box = document.createElement('div');
      box.className = 'xl-scroll';
      parent.insertBefore(box, table);
      box.appendChild(table);
    });

    var toc = document.querySelector('[data-mcb-toc]');
    if (!toc) return;
    var links = toc.querySelectorAll('a');
    var headings = content.querySelectorAll('h2');
    var used = {};
    document.querySelectorAll('[id]').forEach(function (el) {
      used[el.id] = true;
    });

    headings.forEach(function (h, i) {
      if (!h.id) {
        var base = slug(h.textContent);
        var id = base;
        var n = 2;
        while (used[id]) id = base + '-' + n++;
        h.id = id;
        used[id] = true;
      }
      if (links[i]) links[i].setAttribute('href', '#' + h.id);
    });

    // Secțiunea curentă în cuprins.
    if (!('IntersectionObserver' in window) || !headings.length) return;
    var current = null;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var idx = Array.prototype.indexOf.call(headings, entry.target);
          if (current) current.removeAttribute('aria-current');
          current = links[idx] || null;
          if (current) current.setAttribute('aria-current', 'location');
        });
      },
      { rootMargin: '0px 0px -70% 0px' }
    );
    headings.forEach(function (h) {
      observer.observe(h);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
